import React, { useEffect } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { compose } from "recompact"
import { Box } from "@infotech/uikit-grid"
import cn from "classnames"
import isEmpty from "lodash/isEmpty"
import { TrashIcon } from "@infotech/uikit-icons"
import { readList } from "src/engine/modules/lists/actions/creators/read"
import { removeList } from "src/engine/modules/lists/actions/creators/remove"
import {
  DEFAULT_COLOR,
  makeTransparent,
} from "src/containers/Calendar/helpers/eventToItem"
import { LIST_NAME, getBasicUrl } from "./helper"
import styles from "./styles.css"

const EventTypeList = props => {
  const {
    planTypeId,
    readList,
    removeList,
    planTypeEventTypeList,
    refreshList,
    isLoading,
    isDisabled,
  } = props
  useEffect(() => {
    if (!isLoading) {
      readList({
        basicUrl: getBasicUrl(planTypeId),
        name: LIST_NAME,
      })
    }
  }, [planTypeId])

  return (
    <Box loose className={styles.EventTypesWrapper}>
      {planTypeEventTypeList &&
        !planTypeEventTypeList.reading &&
        !isEmpty(planTypeEventTypeList.data) &&
        planTypeEventTypeList.data.map(item => (
          <Box
            loose
            className={styles.CurrentEventType}
            flex
            pl="2md"
            pt="5px"
            pb="1md"
          >
            <Box flex loose>
              <Box loose className={styles.CircleWrapper}>
                <div
                  className={styles.circle}
                  style={{
                    backgroundColor: `${
                      item.color === `#fff`
                        ? DEFAULT_COLOR
                        : makeTransparent(item.color || `#fff`, 0.4)
                    }`,
                  }}
                />
              </Box>
              <Box
                pt="5px"
                pr="2md"
                loose
                className={cn(
                  styles.SelectDropdownOptionLabel,
                  styles.CurrentEventTypeLabel,
                )}
              >
                {item.name}
              </Box>
            </Box>
            {isDisabled ? null : (
              <Box
                loose
                pt="3px"
                className={styles.RightIconWrapper}
                onClick={() => {
                  removeList({
                    basicUrl: getBasicUrl(planTypeId),
                    name: LIST_NAME,
                    id: item.id,
                  })
                  refreshList()
                }}
              >
                <TrashIcon color="#808080" />
              </Box>
            )}
          </Box>
        ))}
    </Box>
  )
}

EventTypeList.propTypes = {
  planTypeId: PropTypes.oneOf([`string`, `number`]).isRequired,
  planTypeEventTypeList: PropTypes.shape({
    color: PropTypes.string,
    name: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
  readList: PropTypes.func.isRequired,
  removeList: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool.isRequired,
}

export default compose(
  connect(null, {
    readList,
    removeList,
  }),
)(EventTypeList)
